<script lang="ts">
	import AlertBox from '$lib/components/atoms/alertBox/AlertBox.svelte';
	import RangeSlider from '$lib/components/atoms/range-slider/RangeSlider.svelte';
	import { DEFAULT_LEVEL_OF_CHARGE } from '$lib/components/itinerary/tripOptions';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	const MAX_LEVEL_OF_CHARGE = 50;
	const MIN_LEVEL_OF_CHARGE = 5;
	const STEP_LEVEL_OF_CHARGE = 5;

	const { tripOptionsStore } = getMapLayoutContext();

	let isMinLevelCharge = $state(false);
</script>

<div>
	<RangeSlider
		label={m.itinerary__options__modes__car_ev_limit()}
		min={MIN_LEVEL_OF_CHARGE}
		max={MAX_LEVEL_OF_CHARGE}
		step={STEP_LEVEL_OF_CHARGE}
		defaultValue={[$tripOptionsStore.rechargeTreshold || DEFAULT_LEVEL_OF_CHARGE]}
		getValueLabel={value => `${value}%`}
		onValueChange={([level]) => {
			isMinLevelCharge = level === MIN_LEVEL_OF_CHARGE;
			track({
				action: 'electric_setup',
				payload: {
					action: 'selection',
					range_rating_alert: level.toString(),
				},
			});
			$tripOptionsStore.rechargeTreshold = level;
		}}
	/>

	{#if isMinLevelCharge}
		<AlertBox
			color="ev"
			icon="info"
			text={m.itinerary__options__modes__car_ev_limit_warning_message()}
			class="mt-3"
		/>
	{/if}
</div>
